import type { BadgeTone } from '@/lib/sheet'
import {
  Ban,
  BadgeCheck,
  Check,
  Globe,
  LogOut,
  type LucideIcon,
  Pencil,
  RotateCcw,
  ShieldCheck,
  ShieldOff,
  Sparkles,
  ToggleRight,
  Unlink,
  Unlock,
  UserCog,
  UserMinus,
  X
} from 'lucide-react'

export const btnPrimary =
  'inline-flex items-center gap-1.5 rounded-[36px] bg-neutral-900 px-4 py-2 text-sm font-bold text-white transition-all hover:bg-neutral-800 active:scale-95 disabled:opacity-50 dark:bg-white dark:text-black dark:hover:bg-neutral-200'

export const btnSecondary =
  'inline-flex items-center gap-1.5 rounded-[36px] border border-neutral-200 bg-white px-4 py-2 text-sm font-semibold text-neutral-900 transition-colors hover:bg-neutral-50 disabled:opacity-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-white dark:hover:bg-neutral-800'

export const btnDanger =
  'inline-flex items-center gap-1.5 rounded-[36px] border border-red-200 bg-white px-4 py-2 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50 disabled:opacity-50 dark:border-red-900/40 dark:bg-neutral-900 dark:text-red-400 dark:hover:bg-red-500/10'

export const iconBtn =
  'inline-flex size-9 items-center justify-center rounded-full text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 dark:text-neutral-400 dark:hover:bg-neutral-800 dark:hover:text-white'

export const TONE_CLASS: Record<BadgeTone, string> = {
  neutral:
    'bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300',
  success:
    'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400',
  warning:
    'bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400',
  danger: 'bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400'
}

// Icon names come from the backend `@admin_action(icon=...)`. Keep this list
// explicit instead of importing lucide's whole icon map into the bundle.
const ICONS: Record<string, LucideIcon> = {
  Ban,
  BadgeCheck,
  Check,
  Globe,
  LogOut,
  Pencil,
  RotateCcw,
  ShieldCheck,
  ShieldOff,
  Sparkles,
  ToggleRight,
  Unlink,
  Unlock,
  UserCog,
  UserMinus,
  X
}

export function actionIcon(name: string): LucideIcon {
  return ICONS[name] ?? Sparkles
}
